import type { CSSObject, Theme } from "@mui/material/styles";

export const sidebarAccordionSx: CSSObject = {
  flex: "0 0 auto",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  width: "100%",
  bgcolor: "white",
  overflow: "hidden",
  borderTop: "1px solid rgba(0, 0, 0, 0.12)",
};

export const sidebarAccordionSummarySx: CSSObject = {
  flexShrink: 0,
  minHeight: 36,
  px: 2,
  display: "flex",
  alignItems: "center",
  gap: 1,
  py: 0.5,
  bgcolor: "rgba(0, 168, 157, 0.06)",
  borderBottom: "1px solid rgba(0, 168, 157, 0.16)",
};

export const sidebarAccordionTitleSx = (theme: Theme): CSSObject => ({
  color: theme.palette.custom.brandTeal,
  fontWeight: 700,
  textTransform: "uppercase",
  fontSize: "0.75rem",
  letterSpacing: "0.04em",
  lineHeight: 1.2,
});

export const sidebarAccordionIconSx: CSSObject = {
  color: "#999",
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
  lineHeight: 0,
};

export const sidebarAccordionContentSx: CSSObject = {
  flex: "1 1 auto",
  minHeight: 0,
  overflowY: "auto",
  overflowX: "hidden",
  px: 1,
  pb: 0.5,
};
